export default __webpack_public_path__ + "static/media/photo--sm--119.836f4ac1.jpg";